



































































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import UiList from '@superUI/List/List'

settings =
  name: 'ScannerShow'
  components: { SuperContainerView, Back, UiList }
  resources:
    item:
      resourceName: 'scanner'
      slug: 'scanners/:scannerId'
    events:
      resourceName: 'event'
      slug: 'scanners/:scannerId/events'
  vue:
    props: ['scannerId']

    data: ->
      eventCheckbox: {}
      selectedEvents: []

    computed:
      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

    methods:
      badgePotential: (item) ->
        return 'unconfirmed' if item.potential_unconfirmed
        return 'confirmed' if item.potential_confirmed
        return 'denied' if item.potential_denied

      badgeState: (item) ->
        return item.state

      badgePublished: (item) ->
        if item.published then 'published' else 'unpublished'

      badgeHorizon: (item) ->
        item.horizon

      hiSelectEvent: (isChecked, event) ->
        if isChecked
          @selectedEvents.push(event)
        else
          @selectedEvents = @selectedEvents.filter((item) -> item.id != event.id)

      hiAddToCampaign: ->
        events = @selectedEvents.map((event) -> event.id)
        @$router.push({ name: 'EventCampaignSelectorPage', params: { events } })

export default VueOptions.vue settings
